export interface HiveTemplate {
  id: string;
  title: string;
  description: string;
  createdAt: string;
  likesCount: number;
  userDistinctViewCount: number;
  userDistinctDuplicationCount: number;
  author: {
    name: string;
    avatarUrl: string;
    position?: string;
    institute?: string;
    city?: string;
    state?: string;
    country?: string;
  };
  thumbnail: string;
  previewUrl: string;
}

export const CustomNavigationMap = {
  all: "Newest",
  top: "Most Popular",
};

export function getNavigationMap(categoryKeys: string[]): { [key: string]: string } {
  return {
    ...CustomNavigationMap,
    ...categoryKeys.reduce<{ [key: string]: string }>((map, category) => {
      map[category] = category;
      return map;
    }, {}),
    newsletter: "Weekly Update"
  };
}
